import PropTypes from 'prop-types';
import styles from './StepNavigation.module.css';

export default function StepNavigation({ 
    title = 'SELECT PRODUCT',
    onNext, 
    onPrevious,
    onViewAllApplied,
    canGoNext = true,
    canGoPrevious = true
}) {
    return (
        <div className={styles.header}>
            {/* Previous Button */}
            <button 
                className={styles.navButton}
                onClick={onPrevious}
                disabled={!canGoPrevious}
                aria-label="Previous step"
            >
                <svg viewBox="0 0 6 10" fill="none" className={styles.navIcon}>
                    <path 
                        d="M5.896907216494845 4.769539078156313 C5.965635738831616 4.836339345357381 6 4.91315965263861 6 5 C6 5.086840347361389 5.965635738831616 5.163660654642618 5.896907216494845 5.230460921843687 L1.092783505154639 9.899799599198397 C1.0240549828178693 9.966599866399466 0.9450171821305842 10 0.8556701030927835 10 C0.766323024054983 10 0.6872852233676976 9.966599866399466 0.6185567010309279 9.899799599198397 L0.10309278350515465 9.39879759519038 C0.0343642611683849 9.331997327989312 0 9.255177020708082 0 9.168336673346694 C0 9.081496325985302 0.0343642611683849 9.004676018704075 0.10309278350515465 8.937875751503006 L4.154639175257731 5 L0.10309278350515465 1.062124248496994 C0.0343642611683849 0.9953239812959247 0 0.9185036740146957 0 0.8316633266533069 C0 0.7448229792919159 0.0343642611683849 0.6680026720106869 0.10309278350515465 0.6012024048096187 L0.6185567010309279 0.1002004008016033 C0.6872852233676976 0.033400133600534065 0.766323024054983 0 0.8556701030927835 0 C0.9450171821305842 0 1.0240549828178693 0.033400133600534065 1.092783505154639 0.1002004008016033 L5.896907216494845 4.769539078156313 Z" 
                        fill="white"
                        transform="scale(-1, 1) translate(-6, 0)"
                    />
                </svg>
            </button>

            {/* Title and Link */}
            <div className={styles.titleSection}>
                <h2 className={styles.title}>{title.toUpperCase()}</h2>
                <button 
                    className={styles.viewAllLink}
                    onClick={onViewAllApplied}
                >
                    View All Applied
                </button>
            </div>

            {/* Next Button */}
            <button 
                className={styles.navButton}
                onClick={onNext}
                disabled={!canGoNext}
                aria-label="Next step"
            >
                <svg viewBox="0 0 6 10" fill="none" className={styles.navIcon}>
                    <path 
                        d="M5.896907216494845 4.769539078156313 C5.965635738831616 4.836339345357381 6 4.91315965263861 6 5 C6 5.086840347361389 5.965635738831616 5.163660654642618 5.896907216494845 5.230460921843687 L1.092783505154639 9.899799599198397 C1.0240549828178693 9.966599866399466 0.9450171821305842 10 0.8556701030927835 10 C0.766323024054983 10 0.6872852233676976 9.966599866399466 0.6185567010309279 9.899799599198397 L0.10309278350515465 9.39879759519038 C0.0343642611683849 9.331997327989312 0 9.255177020708082 0 9.168336673346694 C0 9.081496325985302 0.0343642611683849 9.004676018704075 0.10309278350515465 8.937875751503006 L4.154639175257731 5 L0.10309278350515465 1.062124248496994 C0.0343642611683849 0.9953239812959247 0 0.9185036740146957 0 0.8316633266533069 C0 0.7448229792919159 0.0343642611683849 0.6680026720106869 0.10309278350515465 0.6012024048096187 L0.6185567010309279 0.1002004008016033 C0.6872852233676976 0.033400133600534065 0.766323024054983 0 0.8556701030927835 0 C0.9450171821305842 0 1.0240549828178693 0.033400133600534065 1.092783505154639 0.1002004008016033 L5.896907216494845 4.769539078156313 Z" 
                        fill="white"
                    />
                </svg>
            </button>
        </div>
    );
}

StepNavigation.propTypes = {
    title: PropTypes.string,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func,
    onViewAllApplied: PropTypes.func,
    canGoNext: PropTypes.bool,
    canGoPrevious: PropTypes.bool
};
